/**
 * Modal Manager - Coordina la clase 'modal-open' en el body cuando hay múltiples modales abiertos
 * 
 * Este módulo maneja un contador de modales abiertos para asegurar que la clase
 * 'modal-open' solo se remueva del body cuando el último modal se cierra.
 */

let modalCount = 0

/**
 * Incrementa el contador de modales y agrega la clase al body si es el primero
 */
export function openModal() {
    modalCount++
    if (modalCount === 1) {
        document.body.classList.add('modal-open')
    }
}

/**
 * Decrementa el contador de modales y remueve la clase del body si es el último
 */
export function closeModal() {
    if (modalCount > 0) {
        modalCount--
        if (modalCount === 0) {
            document.body.classList.remove('modal-open')
        }
    }
}
